import type { ReviewCategory } from "../../types";

export type VerticalKey = "cosmetics" | "pet_food" | "baby" | "supplements";

export function verticalToCategory(key: VerticalKey): ReviewCategory {
  if (key === "pet_food") return "food";
  if (key === "supplements") return "supplement";
  return "cosmetic";
}

export const DRAFT_KEY = "xtool_studio_scan_draft";
export const MAX_CLAIM_CHARS = 15000;

export type DraftShape = {
  internalName: string;
  verticalKey: VerticalKey;
  claimsText: string;
  includeFda: boolean;
  attachSeries: boolean;
  /** 勾选关联系列时选中的系列 id */
  selectedSeriesId?: string;
};
